import {BlockType} from 'units/constructor-local/models';
import {
    HeaderBlock as HeaderBlockComponent,
    CalculatorBlock,
    ServiceDemoBlock,
    Services,
    FormBlock,
} from './blocks';

import {
    Form,
    Quote,
    Quotes,
    Event,
    Post,
    Card,
    ServiceCard,
    ServicePreviewCard,
} from './components';

const blocks = {
    [BlockType.Form]: Form,
    [BlockType.Quotes]: Quotes,
    [BlockType.Card]: Card,
    [BlockType.Quote]: Quote,
    [BlockType.Event]: Event,
    [BlockType.Post]: Post,
    [BlockType.ServiceCard]: ServiceCard,
    [BlockType.ServicePreviewCard]: ServicePreviewCard,

    [BlockType.CalculatorBlock]: CalculatorBlock,
    [BlockType.ServiceDemoBlock]: ServiceDemoBlock,
    [BlockType.HeaderBlock]: HeaderBlockComponent,
    [BlockType.ServicesBlock]: Services,
    [BlockType.FormBlock]: FormBlock,
};

export default {blocks};
